import React, { useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import Landing from '../Landing/Landing';
import imageone from '../Media/pure-01.webp'

function Home() {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <Helmet>
                <title>Pure Slimming Juice</title>
                <meta
                    name='description'
                    content='Pure Slimming Juice'
                />
                <meta property="og:image" content={imageone} />

            </Helmet>
            <Landing />
        </div>
    );
}

export default Home;